import { useRef } from 'react'
import { motion, useInView } from 'framer-motion'

const systems = [
  {
    title: 'Sistema nervoso in overload',
    nerd: 'La tua energia mentale è bassa. Ogni azione costa più mana del normale.',
    real: 'Stress cronico, iperattivazione, difficoltà a riposare anche quando dormi.',
    color: '#ef4444',
  },
  {
    title: 'Dopamina distorta',
    nerd: 'Hai abituato il cervello a ricompense istantanee. Le quest lunghe sembrano impossibili.',
    real: 'Stimoli rapidi (scroll, notifiche, episodi) rendono le attività lente intollerabili.',
    color: '#f59e0b',
  },
  {
    title: 'Corpo in standby',
    nerd: 'Il tuo personaggio ha i buff attivi solo online. Offline le stats calano.',
    real: 'Postura, sonno, movimento, alimentazione: tutto scivola in secondo piano.',
    color: '#8b5cf6',
  },
  {
    title: 'Focus frammentato',
    nerd: 'Troppi tab aperti nella testa. Non riesci a concentrarti su una quest per più di 10 minuti.',
    real: 'Attenzione divisa, multitasking forzato, difficoltà a portare a termine anche cose semplici.',
    color: '#00d4ff',
  },
  {
    title: 'Identità bloccata',
    nerd: 'Hai costruito un avatar potente. Poi chiudi lo schermo e non sai più chi sei.',
    real: 'Senso di vuoto, difficoltà a riconoscersi nella vita quotidiana, isolamento sociale.',
    color: '#facc15',
  },
]

export default function WhatHappensSection() {
  const sectionRef = useRef(null)
  const isInView = useInView(sectionRef, { once: true, margin: '-100px' })

  return (
    <section ref={sectionRef} id="diagnosi" className="relative w-full py-12 md:py-18 px-4" style={{ background: '#050510' }}>
      <div className="max-w-5xl mx-auto">
        <motion.div className="text-center mb-14"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold text-nerd-white mb-4">
            Cosa succede{' '}
            <span className="text-gradient">davvero.</span>
          </h2>
          <p className="text-nerd-gray text-base md:text-lg max-w-2xl mx-auto">
            Non è mancanza di forza di volontà. È fisiologia. E la fisiologia si può cambiare.
          </p>
        </motion.div>

        <div className="space-y-5">
          {systems.map((sys, i) => (
            <motion.div
              key={sys.title}
              className="manga-panel rounded-xl p-6 md:p-7 relative group"
              initial={{ opacity: 0, y: 40 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.15 + i * 0.12 }}
            >
              <div className="grid md:grid-cols-2 gap-5 items-center">
                <div>
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-2 h-2 rounded-full" style={{ background: sys.color, boxShadow: `0 0 8px ${sys.color}` }} />
                    <h3 className="font-display text-lg font-bold text-nerd-white">{sys.title}</h3>
                  </div>
                  <p className="text-nerd-gray text-sm leading-relaxed">{sys.real}</p>
                </div>
                <div className="md:border-l md:border-nerd-purple/10 md:pl-5">
                  <div className="inline-block px-3 py-1 rounded-full text-[10px] font-display uppercase tracking-wider mb-2"
                    style={{ background: `${sys.color}12`, color: sys.color, border: `1px solid ${sys.color}25` }}
                  >
                    Traduzione nerd
                  </div>
                  <p className="text-sm italic leading-relaxed" style={{ color: sys.color }}>
                    {sys.nerd}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
